import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store/root-reducer';

export type Config = {
  countryNumber: number;
  countryCode: string;
  manifest: unknown;
  operationId: string;
};

const initialState: Config = {
  countryNumber: 0,
  countryCode: '',
  manifest: {},
  operationId: '',
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setConfig: (state, { payload }) => {
      state.countryNumber = payload.countryNumber;
      state.countryCode = payload.countryCode;
      state.manifest = payload.manifest;
    },
    setOperationId: (state, { payload }) => {
      state.operationId = payload;
    },
  },
});

const { reducer, actions } = configSlice;

export const { setConfig, setOperationId } = actions;

export const ConfigActions = { ...actions };

export const selectCountryNumber = (state: RootState) =>
  state.config.countryNumber;

export const selectCountryCode = (state: RootState) => state.config.countryCode;

export const selectManifest = (state: RootState) => state.config.manifest;

export const selectOperationId = (state: RootState) => state.config.operationId;

export default reducer;
